import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['mediaInputContainer']

  onMediaTypeChange(event) {
    this.mediaInputContainerTargets.forEach(element => {
      element.classList.toggle('hide', element.dataset.mediaType != event.currentTarget.value)
    })
  }
}
